'use client';

// src/skip-nav.tsx
var _excluded = ["id"],
  _excluded2 = ["id"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { chakra, forwardRef, omitThemingProps, useStyleConfig } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var fallbackId = "chakra-skip-nav";
function getStyles(styles) {
  return _objectSpread(_objectSpread({
    userSelect: "none",
    border: "0",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    outline: "0",
    overflow: "hidden",
    position: "absolute",
    clip: "rect(0 0 0 0)"
  }, styles), {}, {
    _focus: _objectSpread({
      clip: "auto",
      width: "auto",
      height: "auto"
    }, styles["_focus"])
  });
}
var SkipNavLink = forwardRef(function SkipNavLink2(props, ref) {
  var styles = useStyleConfig("SkipLink", props);
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$id = _omitThemingProps.id,
    id = _omitThemingProps$id === void 0 ? fallbackId : _omitThemingProps$id,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  return /* @__PURE__ */jsx(chakra.a, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    href: "#".concat(id),
    __css: getStyles(styles)
  }));
});
SkipNavLink.displayName = "SkipNavLink";
var SkipNavContent = forwardRef(function SkipNavContent2(props, ref) {
  var _props$id = props.id,
    id = _props$id === void 0 ? fallbackId : _props$id,
    rest = _objectWithoutProperties(props, _excluded2);
  return /* @__PURE__ */jsx(chakra.div, _objectSpread({
    ref: ref,
    id: id,
    tabIndex: -1,
    style: {
      outline: 0
    }
  }, rest));
});
SkipNavContent.displayName = "SkipNavContent";
export { SkipNavLink, SkipNavContent };